export function dataInJs() {
	var rows = [{
		searchValue: null,
		createBy: null,
		createTime: "2023-03-08 10:39:05",
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 1,
		articleClass: "2",
		Image: require('@/assets/img/dengshan.jpg'),
		articleTitle: "公司组织了爬山活动",
		articleContent: "<h1 style=\"text-align: center;\"><strong>公司组织了爬山活动</strong></h1><p style=\"text-align: center;\"><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;    2015年8月1日星期六，芯航国际（XxinTek）组织了爬山活动，目的地为位于深圳市东部的马峦山。早上7点大家按时间车辆如期按点召集，浩浩荡荡向目的地进发。虽然起得很早，但大家兴致非常高，途中还在微信群里玩起抢红包游戏。</span></p><p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在山底到山顶，全程16公里，海拔500多米。同事们徒步穿越石头、溪水、山路，一路空气清爽，全程16公里，没有一个人掉队，全部爬上山顶，体现了芯航国际大家庭团结互助坚持不懈的团队精神。在途中、山上大家相互玩游戏、交流、放松，太阳很灿烂，同事们也笑得很灿烂，抛开工作生活压力。在摄影的同事中留下了飞舞、开怀、活力的倩影和回忆。我爱你们，芯航国际的兄弟姐妹。</span></p><p><br></p><p style=\"text-align: center;\"></p>",
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: "2022-11-10 14:35:48",
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 2,
		articleClass: "2",
		Image: require('@/assets/img/new1.png'),
		articleTitle: "2015中国（成都）电子展",
		articleContent: "<h1 class=\"ql-align-center\"><strong>2015中国（成都）电子展</strong></h1><p class=\"ql-align-center\"><br></p><p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;     2015年7月16日-18日，芯航国际（XxinTek）参加了2015中国（成都）电子展，芯航国际展位设在成都世纪城新国际会展中心3号馆C247。</span></p><p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;芯航国际主要以英国光电厂牌PHOTE全线产品授权代理、芯商城（</span><a href=\"http://www.gchips.com/\" rel=\"noopener noreferrer\" target=\"_blank\" style=\"color: rgb(51, 51, 51);\">www.gchips.com</a><span style=\"color: rgb(51, 51, 51);\">）线上交易平台、海外原厂代理一手货源价格低货期短、军品优势渠道、OEM偏冷门紧缺器件及世界品牌航空接插件连接器为宣传推广内容，引起前来参观之客户的极大兴趣。观众大数来自射频微波、通信工控、军工产品最终生产工厂采购、当地科研院所之技术人员、中小型研发公司工程师、同行电子元器件贸易分销商等。另外也接洽了美国SAMTEC原厂、全球独立分销商肯沃（CONVERGE）等原厂代理商.</span></p><p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三天的展会，芯航国际共接待了前来询问参观的客户、供应商超过1000人次，派发资料、礼品2000余份，互换名片及客户登记资料800多家。收获颇丰，大大宣传推广了我司代理分销之产品，及拓开了公司产品渠道。</span></p><p><br></p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;芯航国际（XxinTek）总部设在深圳，以北美采购中心、香港物流供应链为依托，已在北京、西安成立分公司，成都、上海推广宣传辐射，大力发展中国市场，解决本地电子分销商、最终用户之渠道、品质、货期等难题。</span></p><p><span style=\"color: rgb(51, 51, 51);\">﻿</p>",
		state: "0"
	}];
	return rows;
}

export function agentInfo() {
	var rows = [{
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 1,
		name: "ES",
		classification: "0",
		brandImage: require('@/assets/img/brand/ES.png'),
		introduction: null,
		state: "0"
	},
	{
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 1,
		name: "NAIKETE",
		classification: "0",
		brandImage: require('@/assets/img/brand/NAIKETE.png'),
		introduction: null,
		state: "0"
	},
	{
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 1,
		name: "ALLPOWER",
		classification: "0",
		brandImage: require('@/assets/img/brand/ALLPOWER.jpg'),
		introduction: null,
		state: "0"
	},
	{
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 1,
		name: "henlv",
		classification: "0",
		brandImage: require('@/assets/img/brand/henlv.jpg'),
		introduction: null,
		state: "0"
	},
    {
        searchValue: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null,
        params: {},
        id: 1,
        name: "slkor",
        classification: "0",
        brandImage: require('@/assets/img/brand/slkor.jpg'),
        introduction: null,
        state: "0"
    }
	];
	return rows;
}

export function brandInfo() {
	var rows = [{
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 1,
		name: "IDT",
		classification: "0",
		brandImage: require('@/assets/img/brand/IDT.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 2,
		name: "LINEAR",
		classification: "0",
		brandImage: require('@/assets/img/brand/LINEAR.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 3,
		name: "ANALOGDEVICES",
		classification: "0",
		brandImage: require('@/assets/img/brand/ANALOGDEVICES.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 4,
		name: "MAXIM",
		classification: "0",
		brandImage: require('@/assets/img/brand/MAXIM.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 5,
		name: "freescale",
		classification: "0",
		brandImage: require('@/assets/img/brand/freescale.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 6,
		name: "national semiconductor",
		classification: "0",
		brandImage: require('@/assets/img/brand/nationalSemiconductor.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 7,
		name: "TEXAS INSTERUMENTS",
		classification: "0",
		brandImage: require('@/assets/img/brand/TEXAS_INSTERUMENTS.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 8,
		name: "ALBRA",
		classification: "0",
		brandImage: require('@/assets/img/brand/ALBRA.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 9,
		name: "XILINX",
		classification: "0",
		brandImage: require('@/assets/img/brand/XILINX.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 10,
		name: "international rectfier",
		classification: "0",
		brandImage: require('@/assets/img/brand/internationalRectfier.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 11,
		name: "Microsemi",
		classification: "0",
		brandImage: require('@/assets/img/brand/Microsemi.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 12,
		name: "Actel",
		classification: "0",
		brandImage: require('@/assets/img/brand/Actel.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 13,
		name: "MACCM",
		classification: "0",
		brandImage: require('@/assets/img/brand/MACCM.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 14,
		name: "TriQuint",
		classification: "0",
		brandImage: require('@/assets/img/brand/TriQuint.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 15,
		name: "avago",
		classification: "0",
		brandImage: require('@/assets/img/brand/avago.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 16,
		name: "SAMSUNG",
		classification: "0",
		brandImage: require('@/assets/img/brand/samsung.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 17,
		name: "MICRON",
		classification: "0",
		brandImage: require('@/assets/img/brand/MICRON.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 18,
		name: "RENESAS",
		classification: "0",
		brandImage: require('@/assets/img/brand/RENESAS.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 19,
		name: "Lattice",
		classification: "0",
		brandImage: require('@/assets/img/brand/Lattice.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 20,
		name: "ON",
		classification: "0",
		brandImage: require('@/assets/img/brand/ON.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 21,
		name: "PICO",
		classification: "0",
		brandImage: require('@/assets/img/brand/PICO.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 22,
		name: "TE",
		classification: "1",
		brandImage: require('@/assets/img/brand/TE.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 23,
		name: "LEMO",
		classification: "1",
		brandImage: require('@/assets/img/brand/LEMO.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 24,
		name: "DEUTSCH * TE",
		classification: "1",
		brandImage: require('@/assets/img/brand/DEUTSCH.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 25,
		name: "DMC",
		classification: "1",
		brandImage: require('@/assets/img/brand/DMC.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 26,
		name: "ERNI",
		classification: "1",
		brandImage: require('@/assets/img/brand/ERNI.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 27,
		name: "Glenair",
		classification: "1",
		brandImage: require('@/assets/img/brand/Glenair.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 28,
		name: "Esterline",
		classification: "1",
		brandImage: require('@/assets/img/brand/Esterline.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 29,
		name: "ITT",
		classification: "1",
		brandImage: require('@/assets/img/brand/ITT.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 30,
		name: "Amphenol",
		classification: "1",
		brandImage: require('@/assets/img/brand/Amphenol.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 31,
		name: "Reychem",
		classification: "1",
		brandImage: require('@/assets/img/brand/Reychem.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 32,
		name: "TROMPETER",
		classification: "1",
		brandImage: require('@/assets/img/brand/TROMPETER.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 33,
		name: "samtec",
		classification: "1",
		brandImage: require('@/assets/img/brand/samtec.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 34,
		name: "CINCH",
		classification: "1",
		brandImage: require('@/assets/img/brand/CINCH.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 35,
		name: "AirBorn",
		classification: "1",
		brandImage: require('@/assets/img/brand/AirBorn.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 36,
		name: "JUDD WIRE INC",
		classification: "1",
		brandImage: require('@/assets/img/brand/JUDD_WIRE_INC.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 37,
		name: "harbour",
		classification: "1",
		brandImage: require('@/assets/img/brand/harbour.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 38,
		name: "TRI-STAR",
		classification: "1",
		brandImage: require('@/assets/img/brand/TRI-STAR.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 39,
		name: "exans",
		classification: "1",
		brandImage: require('@/assets/img/brand/exans.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 40,
		name: "Ulti-mate",
		classification: "1",
		brandImage: require('@/assets/img/brand/Ulti-mate.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 41,
		name: "GORE",
		classification: "1",
		brandImage: require('@/assets/img/brand/GORE.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 42,
		name: "C&K",
		classification: "2",
		brandImage: require('@/assets/img/brand/C&K.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 43,
		name: "COLE",
		classification: "2",
		brandImage: require('@/assets/img/brand/COLE.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 44,
		name: "grayhill",
		classification: "2",
		brandImage: require('@/assets/img/brand/grayhill.jpg'),
		introduction: null,
		state: "0"
	}, {
		searchValue: null,
		createBy: null,
		createTime: null,
		updateBy: null,
		updateTime: null,
		remark: null,
		params: {},
		id: 45,
		name: "Honeywell",
		classification: "2",
		brandImage: require('@/assets/img/brand/Honeywell.jpg'),
		introduction: null,
		state: "0"
	}];
	return rows;
}
